import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../../../common/CmnContext';
import { LiveReserveContext } from '../../../../LiveLessonReseveContext';


function LiveReserveSelectInstructorModalSelected(props: any) {
  const isPc = useContext(cmnContext).isPc;
  const { setInstId } = useContext(LiveReserveContext);

  const selectInst = props.selectInst;

  return (
    <>
      {/* 選択中 */}
      {selectInst &&
        <>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: isPc? '0 20px' : '0 10px',
          }}>
            <div>選択中： <span>{selectInst?.name} 講師（{selectInst?.schedule_count}枠）</span></div>
            <div
              className='btn btn-sm btn-danger'
              style={{padding: '5px 10px'}}
              onClick={() => {setInstId('');}}
            >取消</div>
          </div>
          <hr style={{margin: '5px 0'}} />
        </>
      }
    </>
  );
}
  
export default LiveReserveSelectInstructorModalSelected;